import React from 'react';
import { Spinner } from 'react-bootstrap';
import { NavTabType, NavTabs } from '~/components/Patient/NavTabs';

interface ActivityFeedTabsProps {
    page: string;
    setPage: (x: string) => void;
    tabValue: { [key: string]: string | number };
}
export function ActivityFeedTabs({ page, setPage, tabValue }: ActivityFeedTabsProps) {
    const tabs: NavTabType[] = [
        { label: 'Health Hx', val: 'healthhx' },
        { label: 'Activity', val: 'history' },
        { label: 'Reminders', val: 'reminders' },
        { label: 'Notes', val: 'notes' },
    ].map((x: NavTabType) => {
        if (typeof tabValue[x.val] !== 'undefined' && tabValue[x.val] !== '') {
            if (tabValue[x.val] === 'pending') {
                x.label = (
                    <>
                        {x.label} (
                        <Spinner animation="border" size="sm" role="status" variant="secondary" />)
                    </>
                );
            } else {
                x.label += ` (${tabValue[x.val]})`;
            }
        }
        return x;
    });
    return <NavTabs tabs={tabs} page={page} setPage={setPage} />;
}
